import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends, toConsumableArray as _toConsumableArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { useRef, useMemo } from 'react';
import { utils, useSize, Flex, Box, fillContainer, Skeleton, List, ListItem, ListItemText } from '@costar/theme-ui';
import TransferListItem from './transfer-list-item.esm.js';
import { FixedSizeList } from 'react-window';
import Placeholder from './placeholder.esm.js';

var _excluded = ["variant", "fontSize", "listItemProps", "items", "isSelectedList", "availableOptions", "selectListHeaderComponent", "hideSelectListFooterComponent", "availableListHeaderComponent", "hasLockSelections", "lastChecked", "showCheckBox", "filter", "checked", "areOptionsLoaded", "noOptionsAvailable", "noSelectedOptionsAvailable", "lastSelectedRef", "activeListSearchProps", "selectionPlaceHolder", "showLockIcon", "enableVirtualizeList", "virtualizeRowHeight", "handleToggle", "loading"];
var renderPlaceholder = function renderPlaceholder() {
  return /*#__PURE__*/React.createElement(Placeholder, null);
};
var listReset = {
  margin: undefined
};
var OptionList = function OptionList(props) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'transferList' : _props$variant,
    fontSize = props.fontSize,
    _props$listItemProps = props.listItemProps,
    listItemProps = _props$listItemProps === void 0 ? utils.EMPTY_OBJECT : _props$listItemProps,
    items = props.items,
    isSelectedList = props.isSelectedList,
    _props$availableOptio = props.availableOptions,
    availableOptions = _props$availableOptio === void 0 ? utils.EMPTY_OBJECT : _props$availableOptio,
    selectListHeaderComponent = props.selectListHeaderComponent,
    hideSelectListFooterComponent = props.hideSelectListFooterComponent,
    availableListHeaderComponent = props.availableListHeaderComponent,
    hasLockSelections = props.hasLockSelections,
    lastChecked = props.lastChecked,
    showCheckBox = props.showCheckBox,
    filter = props.filter,
    checked = props.checked,
    areOptionsLoaded = props.areOptionsLoaded,
    _props$noOptionsAvail = props.noOptionsAvailable,
    noOptionsAvailable = _props$noOptionsAvail === void 0 ? 'No options' : _props$noOptionsAvail,
    _props$noSelectedOpti = props.noSelectedOptionsAvailable,
    noSelectedOptionsAvailable = _props$noSelectedOpti === void 0 ? 'No selected options' : _props$noSelectedOpti,
    lastSelectedRef = props.lastSelectedRef,
    activeListSearchProps = props.activeListSearchProps,
    _props$selectionPlace = props.selectionPlaceHolder,
    selectionPlaceHolder = _props$selectionPlace === void 0 ? renderPlaceholder : _props$selectionPlace,
    showLockIcon = props.showLockIcon,
    enableVirtualizeList = props.enableVirtualizeList,
    _props$virtualizeRowH = props.virtualizeRowHeight,
    virtualizeRowHeight = _props$virtualizeRowH === void 0 ? 28 : _props$virtualizeRowH,
    handleToggle = props.handleToggle,
    loading = props.loading,
    rest = _objectWithoutProperties(props, _excluded);
  var listProps = _objectSpread2({
    variant: variant,
    fontSize: fontSize,
    py: 0
  }, rest);
  var wrapperRef = useRef(null);
  var wrapperSize = useSize(wrapperRef);
  var _wrapperSize$width = wrapperSize.width,
    width = _wrapperSize$width === void 0 ? 0 : _wrapperSize$width,
    _wrapperSize$height = wrapperSize.height,
    height = _wrapperSize$height === void 0 ? 0 : _wrapperSize$height;
  var renderRow = function renderRow(props) {
    if (!props) return null;
    var _ref = props || {},
      index = _ref.index,
      style = _ref.style;
    var value = items[index];
    return /*#__PURE__*/React.createElement(TransferListItem, {
      key: "transfer-list-item-".concat(index),
      activeListSearchProps: activeListSearchProps,
      availableOptions: availableOptions,
      checked: checked.indexOf(value) !== -1,
      hasLockSelections: hasLockSelections,
      isSelectedList: isSelectedList,
      lastChecked: lastChecked,
      lastSelectedRef: lastSelectedRef,
      listItemProps: listItemProps,
      showCheckBox: showCheckBox,
      showLockIcon: showLockIcon,
      value: value,
      handleToggle: handleToggle,
      style: style
    });
  };
  var containerBorderStyle = useMemo(function () {
    return _objectSpread2({}, loading ? undefined : isSelectedList && selectListHeaderComponent ? _objectSpread2({
      borderLeft: 'neutral.medium',
      borderRight: 'neutral.medium'
    }, hideSelectListFooterComponent ? {
      borderBottom: 'neutral.medium'
    } : {}) : !isSelectedList && availableListHeaderComponent ? {
      borderLeft: 'neutral.medium',
      borderRight: 'neutral.medium',
      borderBottom: 'neutral.medium'
    } : {
      border: 'neutral.medium'
    });
  }, [availableListHeaderComponent, hideSelectListFooterComponent, isSelectedList, loading, selectListHeaderComponent]);
  // eslint-disable-next-line no-console
  // console.log(
  //   `---- rendering transfer-list option-list ${
  //     isSelectedList ? 'selected' : 'options'
  //   }----`
  // )
  return enableVirtualizeList ? /*#__PURE__*/React.createElement(Flex, {
    relative: true,
    flexDirection: "column",
    minHeight: 0,
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Box, _extends({
    ref: wrapperRef,
    zIndex: "1",
    overflow: "hidden"
  }, _objectSpread2(_objectSpread2({}, fillContainer), containerBorderStyle)), loading ? /*#__PURE__*/React.createElement(Skeleton, {
    width: width,
    height: height,
    variant: "rect"
  }) : isSelectedList && items.length === 0 ? /*#__PURE__*/React.createElement(Flex, {
    relative: true,
    height: "100%",
    alignItems: "center",
    p: "md"
  }, typeof selectionPlaceHolder === 'function' ? selectionPlaceHolder() : selectionPlaceHolder) : /*#__PURE__*/React.createElement(FixedSizeList, {
    className: "csg-tui-virtualized-list csg-tui-scrollbar",
    width: width,
    height: height,
    itemSize: virtualizeRowHeight,
    itemCount: items.length
  }, renderRow))) : /*#__PURE__*/React.createElement(List, _extends({
    dense: true,
    resetCss: listReset,
    role: "list",
    overflow: "auto",
    borderRadius: "none",
    zIndex: "1",
    isLoading: loading,
    flex: "1",
    "automation-id": isSelectedList ? 'csg-trl-selected-list-container' : 'csg-trl-available-list-container'
  }, _objectSpread2(_objectSpread2({}, listProps), containerBorderStyle)), isSelectedList && items.length === 0 ? /*#__PURE__*/React.createElement(Flex, {
    relative: true,
    height: "100%",
    alignItems: "center",
    p: "md"
  }, typeof selectionPlaceHolder === 'function' ? selectionPlaceHolder() : selectionPlaceHolder) : utils.isEmptyObject(availableOptions) ? areOptionsLoaded ? /*#__PURE__*/React.createElement(ListItem, {
    disabled: true
  }, /*#__PURE__*/React.createElement(ListItemText, null, isSelectedList ? noSelectedOptionsAvailable : noOptionsAvailable)) : _toConsumableArray(Array(10).keys()).map(function (value) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: value,
      role: "listitem"
    }, /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement(Skeleton, {
      variant: "text",
      animation: "wave",
      height: "1.5em"
    })));
  }) : items.filter(function (value) {
    return isSelectedList || !(filter !== null && filter !== void 0 && filter.length) || filter.includes(value);
  })
  //Avoid a race condition in case availableOptions changes before selectedOptions.
  .filter(function (value) {
    return availableOptions[value];
  }).map(function (value, idx) {
    return /*#__PURE__*/React.createElement(TransferListItem, {
      key: "transfer-item-".concat(idx),
      activeListSearchProps: activeListSearchProps,
      availableOptions: availableOptions,
      checked: checked.indexOf(value) !== -1,
      hasLockSelections: hasLockSelections,
      isSelectedList: isSelectedList,
      lastChecked: lastChecked,
      lastSelectedRef: lastSelectedRef,
      listItemProps: listItemProps,
      showCheckBox: showCheckBox,
      showLockIcon: showLockIcon,
      value: value,
      handleToggle: handleToggle
    });
  }));
};

export default OptionList;
//# sourceMappingURL=option-list.esm.js.map
